module.exports = __webpack_public_path__ + "static/media/white-play-button.fe40969e.png";